enum Path {
  Home = "/",
  Order = "/order",
}

export default Path;
